import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f746b64e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mass-tool" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "desc" }, "批量操作", -1))
const _hoisted_4 = { class: "selections" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 已选择 ")
const _hoisted_6 = { class: "select-count" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 条记录 ")
const _hoisted_8 = { class: "right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.ids.length), 1),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}